import { alpha, createTheme } from "@mui/material/styles";

/** InHouse brand — мастило от лого/надписи; ярките цветове са за модули. */
const brand = {
    primary: "#14325c",
    primaryDark: "#0f2340",
    primaryLight: "#3d5f8f",
    ink: "#14325c",
    muted: "#6b7c90",
    line: "#e8eef6",
    canvas: "#f5f8fc",
};

export const appTheme = createTheme({
    palette: {
        primary: {
            main: brand.primary,
            dark: brand.primaryDark,
            light: brand.primaryLight,
        },
        secondary: {
            main: "#7b5cff",
        },
        background: {
            default: brand.canvas,
            paper: "#ffffff",
        },
        text: {
            primary: brand.ink,
            secondary: brand.muted,
        },
        divider: brand.line,
    },
    shape: {
        borderRadius: 22,
    },
    typography: {
        fontFamily: '"Manrope", "Segoe UI", sans-serif',
        h2: {
            fontSize: "clamp(2.25rem, 4vw, 3.75rem)",
            fontWeight: 800,
            letterSpacing: "-0.04em",
            lineHeight: 1,
        },
        h3: {
            fontSize: "clamp(1.6rem, 2vw, 2.2rem)",
            fontWeight: 800,
            letterSpacing: "-0.03em",
        },
        h4: {
            fontSize: "clamp(1.3rem, 1.4vw, 1.8rem)",
            fontWeight: 800,
            letterSpacing: "-0.03em",
        },
        h5: {
            fontSize: "1.1rem",
            fontWeight: 800,
        },
        overline: {
            fontWeight: 800,
            letterSpacing: "0.16em",
        },
        button: {
            textTransform: "none",
            fontWeight: 700,
        },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    margin: 0,
                    minHeight: "100dvh",
                    overflowX: "clip",
                    background:
                        "radial-gradient(circle at top left, rgba(20, 50, 92, 0.08), transparent 36%), radial-gradient(circle at top right, rgba(123, 92, 255, 0.06), transparent 28%), radial-gradient(circle at bottom left, rgba(53, 208, 127, 0.05), transparent 30%), #f5f8fc",
                },
                "#root": {
                    minHeight: "100dvh",
                    width: "100%",
                    maxWidth: "100%",
                    overflowX: "clip",
                },
            },
        },
        MuiTabs: {
            defaultProps: {
                variant: "scrollable",
                scrollButtons: "auto",
                allowScrollButtonsMobile: true,
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    minHeight: 44,
                    minWidth: "auto",
                    padding: "10px 14px",
                    textTransform: "none",
                    fontWeight: 700,
                },
            },
        },
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    width: "100%",
                    maxWidth: "100%",
                    overflowX: "auto",
                    WebkitOverflowScrolling: "touch",
                },
            },
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    "@media (pointer: coarse)": {
                        padding: 10,
                    },
                },
            },
        },
        MuiDialog: {
            defaultProps: {
                fullScreen: false,
            },
            styleOverrides: {
                paper: {
                    margin: 12,
                    width: "calc(100% - 24px)",
                    maxHeight: "calc(100dvh - 24px)",
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: "none",
                    boxShadow: "0 18px 42px rgba(20, 50, 92, 0.07)",
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 999,
                    paddingInline: 18,
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    "& .MuiOutlinedInput-root": {
                        borderRadius: 18,
                        backgroundColor: alpha("#ffffff", 0.9),
                    },
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    fontWeight: 800,
                    color: brand.ink,
                    backgroundColor: alpha(brand.primary, 0.04),
                },
                root: {
                    borderColor: brand.line,
                },
            },
        },
    },
});
